import React, { useEffect, useMemo, useState } from "react";
import MetaTags from "react-meta-tags";
import { useHistory } from "react-router-dom";
import { HiOutlineAcademicCap, HiOutlineCalendarDays } from "react-icons/hi2";
import axios from "axios";
import NewsList from "../Components/NewsList";
import { InlineLoading } from "../Components/LoadingOverlay";
import {
  BUNDIT_ROUND_BUTTONS,
  BUNDIT_ROUND_GROUPS,
  groupRoundButtons,
} from "../config/admissionRound";
import RoundImageRows from "../Components/RegisterRounds/RoundImageRows";
import { admission } from "../config/api";
import "./Register.css";
import "../Components/RegisterRounds/RegisterRounds.css";

import brob1 from "../assets/2027/bundit/brob1.png";
import brob2 from "../assets/2027/bundit/brob2.png";
import brob3 from "../assets/2027/bundit/brob3.png";

const IMAGES = { brob1, brob2, brob3 };

/**
 * สเต็ป 1 — เลือกรอบบัณฑิตศึกษา
 * URL: /select-bundit
 * กดรอบที่เปิด → /select-bundit/:robId (เลือกระดับ โท/เอก)
 */
function Select_bundit() {
  const history = useHistory();
  const [News, setNews] = useState([]);
  const [loadingNews, setLoadingNews] = useState(true);

  const groups = useMemo(
    () => groupRoundButtons(BUNDIT_ROUND_BUTTONS, BUNDIT_ROUND_GROUPS, IMAGES),
    []
  );

  useEffect(() => {
    axios
      .get(admission + "/administrator_new/show/3")
      .then((res) => {
        setNews(res.data && res.data.length ? res.data : []);
      })
      .catch(() => setNews([]))
      .finally(() => setLoadingNews(false));
  }, []);

  const onSelectRound = (event) => {
    const robId = event?.target?.id;
    if (!robId) {
      return;
    }
    const round = BUNDIT_ROUND_BUTTONS.find((r) => String(r.id) === String(robId));
    if (!round || !round.open) {
      return;
    }
    history.push(`/select-bundit/${robId}`);
  };

  return (
    <>
      <MetaTags>
        <title>เลือกรอบบัณฑิตศึกษา | มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
        <meta
          name="description"
          content="เลือกรอบสมัครเรียนระดับปริญญาโท - ปริญญาเอก มหาวิทยาลัยราชภัฏกำแพงเพชร"
        />
        <meta property="og:title" content="เลือกรอบบัณฑิตศึกษา" />
      </MetaTags>

      <div className="reg-page">
        <div className="reg-hero">
          <p className="reg-hero__eyebrow">มหาวิทยาลัยราชภัฏกำแพงเพชร</p>
          <h1 className="reg-hero__title">
            <HiOutlineAcademicCap size={28} aria-hidden />
            สมัครเรียนระดับบัณฑิตศึกษา
          </h1>
          <p className="reg-hero__desc">เลือกช่วงรับสมัครที่ต้องการก่อน แล้วค่อยเลือกระดับปริญญา</p>
        </div>

        <div className="reg-steps">
          <div className="reg-step is-active">
            <HiOutlineCalendarDays size={16} aria-hidden />
            1. เลือกรอบ
          </div>
          <div className="reg-step">2. เลือกระดับ ป.โท / ป.เอก</div>
        </div>

        <div className="reg-panel">
          <h2 className="reg-panel__title">
            <HiOutlineCalendarDays size={20} aria-hidden />
            เลือกรอบที่ต้องการสมัคร
          </h2>
          <p className="reg-panel__hint">
            กดที่รอบที่เปิดรับสมัคร (รอบที่ปิดจะแสดงจางกว่าและกดไม่ได้)
          </p>

          {groups.length === 0 ? (
            <p className="reg-empty">ยังไม่มีรอบเปิดสมัครเรียน</p>
          ) : (
            <RoundImageRows
              groups={groups}
              selectedRobId=""
              onSelect={onSelectRound}
              className="reg-rounds--banner"
            />
          )}
        </div>

        {loadingNews ? (
          <InlineLoading label="กำลังโหลดข่าวประชาสัมพันธ์..." />
        ) : News.length !== 0 ? (
          <NewsList items={News} previewCount={3} collapsible />
        ) : null}
      </div>
    </>
  );
}

export default Select_bundit;
